export default __webpack_public_path__ + "static/media/LinkedIn.94bf6a38.png";